module.exports = __webpack_public_path__ + "img/gh-36006-4.prt.bf9b5ca7.jpg";